import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Configuración de Firebase - everyprojects
const firebaseConfig = {
  apiKey: "AIzaSyBU59DcG3nLdT6xG6cSKA9ncx1EirkyPcE",
  authDomain: "everyprojects-12f84.firebaseapp.com",
  projectId: "everyprojects-12f84",
  storageBucket: "everyprojects-12f84.firebasestorage.app",
  messagingSenderId: "600857895380",
  appId: "1:600857895380:web:4bace76b09188ccf857641",
  measurementId: "G-F3YHTQ3NVF"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);